﻿<template>
  <div class="content-block">
    <PmwParagraph
      class="content-block--title"
      size="paragraph-60"
      weight="medium"
    >
      <Icon v-if="icon" :icon="icon" class="content-block--icon" /> {{ title }}
    </PmwParagraph>

    <div
      :class="{ 'content-block-content__padding': contentPadding }"
      class="content-block-content"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'ContentBlock',

  components: {
    PmwParagraph
  },

  props: {
    title: {
      type: String,
      default: 'Título do bloco'
    },

    /** ícone do título */
    icon: {
      type: String,
      default: null
    },

    /** Adicionar padding ao conteúdo */
    contentPadding: Boolean
  }
}
</script>

<style lang="scss" scoped>
.content-block {
  &--title {
    margin-bottom: pmw-space(2);
  }

  &--icon {
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }

  &-content {
    &__padding {
      padding: {
        left: pmw-space(3);
        right: pmw-space(3);
      }
    }
  }
}
</style>
